import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M11 21a2 2 0 0 0-1.803-1.99L9 19H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h6a5 5 0 0 1 4 2.001A5 5 0 0 1 16 2h6a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1h-7a2 2 0 0 0-2 2 1 1 0 1 1-2 0m-8-4h6a4 4 0 0 1 2 .537V7a3 3 0 0 0-3-3H3zm10 .537A4 4 0 0 1 15 17h6V4h-5a3 3 0 0 0-3 3z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11 21a2 2 0 0 0-1.803-1.99L9 19H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h6a5 5 0 0 1 4 2.001A5 5 0 0 1 16 2h6a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1h-7a2 2 0 0 0-2 2 1 1 0 1 1-2 0m-8-4h6a4 4 0 0 1 2 .537V7a3 3 0 0 0-3-3H3zm10 .537A4 4 0 0 1 15 17h6V4h-5a3 3 0 0 0-3 3z"
    }, null, -1)
  ]))]))
}
export default { render: render }